module.exports = __webpack_public_path__ + "media/images/lb/068-a0a7ca9630fad8ea6ff78d03b593a4e8.svg";